import { Section } from '@/lib/types/apiTypes';
import { FC } from 'react';
import Document from '../ui/icons/Document';
import Comments from '../ui/icons/Comments';

interface DesignIconsProps {
	section: Section;
}

const DesignIcons: FC<DesignIconsProps> = ({ section }) => {
	return (
		<div className="absolute flex items-center gap-3 bottom-10 right-14">
			<div className="relative right-8 cursor-lock">
				<div className="border border-[#5d9bfd] rounded-lg w-9 h-11 p-1  -translate-x-1/2 top-2/4 left-2/4 absolute -translate-y-1/2">
					<Document />
				</div>
				<div className=" text-[#5d9bfd] font-bold text-lg">
					{section.sectionDocuments.length ?? 0}
				</div>
			</div>
			<div className="relative cursor-lock">
				<div className="border border-[#5d9bfd] rounded-lg w-9 h-11 p-1 -translate-x-1/2 top-2/4 left-2/4 absolute -translate-y-1/2">
					<Comments />
				</div>
				<div className=" text-[#5d9bfd] font-bold text-lg -translate-x-1/2 top-2/4 left-2/4 absolute -translate-y-1/2">
					{section.comments.length ?? 0}
				</div>
			</div>
		</div>
	);
};

export default DesignIcons;
